import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stages from '../../../BuildingBlocks/Lines/Stages/Stages';
import CustomTooltip from '../../../BuildingBlocks/Tooltip/Tooltip';

const useStyles = makeStyles((theme: any) => ({
  timeline: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
  },
  timelineContainer: {
    backgroundColor: 'rgba(3, 56, 56, 0.04)',
    height: theme.spacing(28),
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  stagesContainer: {
    display: 'flow-root',
  },
}));

export default function ExampleLineDesktop({
  line,
  handleStageUpdate = null,
  addStage = null,
  addOrDeleteError = null,
  className = ' ',
}) {
  const classes = useStyles();
  const [openStockOnHand, setOpenStockOnHand] = useState(false);
  line.stages = line.stages.filter((stage) => !stage.deleted);

  return (
    <>
      <div className={classes.timelineContainer}>
        <div className={classes.stagesContainer}>
          <div className={classes.timeline + ' ' + className}>
            <Stages
              line={line}
              numColumns={line.stages.length - 1}
              onboarding={true}
              handleStageUpdate={handleStageUpdate}
              addStage={addStage}
              addOrDeleteError={addOrDeleteError}
              exampleStages={true}
              openStockOnHand={openStockOnHand}
              setOpenStockOnHand={setOpenStockOnHand}
            />
          </div>
        </div>
      </div>
      <div className={classes.timelineContainer}>
        <CustomTooltip
          arrow
          title={'Example of a complete supply chain Line'}
          placement="bottom"
          open={true}
        >
          <div className={classes.stagesContainer}>
            <div className={classes.timeline + ' ' + className}>
              <Stages
                line={line}
                numColumns={line.stages.length - 1}
                onboarding={true}
                handleStageUpdate={handleStageUpdate}
                addStage={addStage}
                addOrDeleteError={addOrDeleteError}
                openStockOnHand={openStockOnHand}
                setOpenStockOnHand={setOpenStockOnHand}
              />
            </div>
          </div>
        </CustomTooltip>
      </div>
    </>
  );
}
